export enum QrCodeActions {
    TRACK_SCREEN_LOADING = "TRACK_SCREEN_LOADING",
    TRACK_SCREEN_SUCCESS = "TRACK_SCREEN_SUCCESS",
    TRACK_SCREEN_RESET = "TRACK_SCREEN_RESET",
    PLACE_ORDER_UPDATE = "PLACE_ORDER_UPDATE",
    TRACK_SCREEN_ERROR = "TRACK_SCREEN_ERROR",
    BILL_SUMMARY_LOADING = "BILL_SUMMARY_LOADING",
    BILL_SUMMARY_SUCCESS = "BILL_SUMMARY_SUCCESS",
    BILL_SUMMARY_ERROR = "BILL_SUMMARY_ERROR",
    MENU_SCREEN_LOADING = "MENU_SCREEN_LOADING",
    MENU_SCREEN_RESET = "MENU_SCREEN_RESET",
    MENU_SCREEN_SUCCESS = "MENU_SCREEN_SUCCESS",
    MENU_SCREEN_UPDATE_REQUEST_ID = "MENU_SCREEN_UPDATE_REQUEST_ID",
    MENU_SCREEN_UPDATE_CONFIGS = "MENU_SCREEN_UPDATE_CONFIGS",
    MENU_SCREEN_ERROR = "MENU_SCREEN_ERROR",
    CART_SCREEN_LOADING = "CART_SCREEN_LOADING",
    CART_SCREEN_SUCCESS = "CART_SCREEN_SUCCESS",
    CART_SCREEN_ERROR = "CART_SCREEN_ERROR",
    CART_UPDATE_LOADING = "CART_UPDATE_LOADING",
    CART_UPDATE_SUCCESS = "CART_UPDATE_SUCCESS",
    CART_UPDATE_ERROR = "CART_UPDATE_ERROR",
    UPDATE_LOCAL_CART = "UPDATE_LOCAL_CART",
    PLACE_ORDER_ERROR = "PLACE_ORDER_ERROR",
    PLACE_ORDER_RESET = "PLACE_ORDER_RESET",
    CLEAR_LOCAL_CART = "CLEAR_LOCAL_CART",
    CURTAIN_SCREEN_LOADING = "CURTAIN_SCREEN_LOADING",
    CURTAIN_SCREEN_SUCCESS = "CURTAIN_SCREEN_SUCCESS",
    CURTAIN_SCREEN_ERROR = "CURTAIN_SCREEN_ERROR",
    PIN_GENERATION_LOADING = "PIN_GENERATION_LOADING",
    PIN_GENERATION_RESET = "PIN_GENERATION_RESET",
    PIN_GENERATION_SUCCESS = "PIN_GENERATION_SUCCESS",
    PIN_GENERATION_FAILURE = "PIN_GENERATION_FAILURE",
    UPDATE_INITIAL_MENU = "UPDATE_INITIAL_MENU",
    UPDATE_FILTER_DATA = "UPDATE_FILTER_DATA",
    UPDATE_DATA_BY_PARENT_TYPE = "UPDATE_DATA_BY_PARENT_TYPE",
    UPDATE_DATA_BY_CATEGORY = "UPDATE_DATA_BY_CATEGORY",
    UPDATE_DATA_PREFERENCE = "UPDATE_DATA_PREFERENCE",

    COLLECTIONS_SCREEN_LOADING = "COLLECTIONS_SCREEN_LOADING",
    COLLECTIONS_SCREEN_SUCCESS = "COLLECTIONS_SCREEN_SUCCESS",
    COLLECTIONS_SCREEN_ERROR = "COLLECTIONS_SCREEN_ERROR",
    UPDATE_INITIAL_COLLECTIONS = "UPDATE_INITIAL_COLLECTIONS",
    UPDATE_COLLECTIONS_FILTER_DATA = "UPDATE_COLLECTIONS_FILTER_DATA",
    UPDATE_COLLECTIONS_BY_PARENT_TYPE = "UPDATE_COLLECTIONS_BY_PARENT_TYPE",
    UPDATE_COLLECTIONS_PREFERENCE = "UPDATE_COLLECTIONS_PREFERENCE",

    SHOW_TOAST = "SHOW_TOAST",
    DISMISS_TOAST = "DISMISS_TOAST",
    SHOW_PAYMENT_FAILURE = "SHOW_PAYMENT_FAILURE",
    HIDE_PAYMENT_FAILURE = "HIDE_PAYMENT_FAILURE",

    CROSS_SELL_ADD_ENTRY = "CROSS_SELL_ADD_ENTRY",
    CROSS_SELL_REMOVE_ENTRY = "CROSS_SELL_REMOVE_ENTRY",
    CROSS_SELL_CONFIG_LOADED = "CROSS_SELL_CONFIG_LOADED",
    CROSS_SELL_SET_SHOWN_ITEMS = "CROSS_SELL_SET_SHOWN_ITEMS",
}
